import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { setGA4UserIdFromDevice } from '../utils/ga4Utils';

export function useGaPageview() {
  const location = useLocation();

  useEffect(() => {
    const measurementId = window.GA_MEASUREMENT_ID;
    const gtag = window.gtag;
    if (!measurementId || typeof gtag !== 'function') return;

    // GA4 user_id 설정
    setGA4UserIdFromDevice();

    const pagePath = location.pathname + (location.search || '');
    gtag('config', measurementId, { page_path: pagePath });
  }, [location.pathname, location.search]);
}

export default function GaRouterTracker() {
  useGaPageview();
  return null;
}


